import { defineStore } from 'pinia';

// Cartões do copiloto de ligação ao vivo (eventos copilot.card e
// copilot.status do VoipCallChannel). No máximo MAX_COPILOT_CARDS por ligação,
// o mais novo em cima; cada cartão some sozinho depois de COPILOT_CARD_TTL_MS.
export const MAX_COPILOT_CARDS = 3;
export const COPILOT_CARD_TTL_MS = 20000;

const timers = new Map();
let sequence = 0;

const sameCall = (a, b) => String(a) === String(b);

export const useCallCopilotStore = defineStore('callCopilot', {
  state: () => ({
    cards: [],
    statusByCall: {},
  }),

  getters: {
    cardsFor: state => callRecordId =>
      state.cards.filter(card => sameCall(card.callRecordId, callRecordId)),
    statusFor: state => callRecordId =>
      state.statusByCall[String(callRecordId)] || null,
  },

  actions: {
    addCard(payload) {
      const card = payload?.card;
      if (!payload?.call_record_id || !card?.suggestion) return;

      sequence += 1;
      const entry = {
        key: `${payload.call_record_id}-${card.id}-${sequence}`,
        callRecordId: payload.call_record_id,
        id: card.id,
        kind: card.kind,
        stage: card.stage || '',
        objection: card.objection || '',
        suggestion: card.suggestion,
        triggerText: payload.trigger_text || '',
        latencyMs: payload.latency_ms ?? null,
      };
      // O mesmo cartão de novo sobe para o topo; passou do limite, sai o mais velho.
      const replaced = this.cards.filter(
        item =>
          sameCall(item.callRecordId, entry.callRecordId) &&
          item.id === entry.id
      );
      const rest = this.cards.filter(item => !replaced.includes(item));
      const sameCallCards = rest.filter(item =>
        sameCall(item.callRecordId, entry.callRecordId)
      );
      const dropped = [
        ...replaced,
        ...sameCallCards.slice(MAX_COPILOT_CARDS - 1),
      ];
      dropped.forEach(item => this.clearTimer(item.key));
      this.cards = [entry, ...rest.filter(item => !dropped.includes(item))];
      timers.set(
        entry.key,
        setTimeout(() => this.dismiss(entry.key), COPILOT_CARD_TTL_MS)
      );
    },

    dismiss(key) {
      this.clearTimer(key);
      this.cards = this.cards.filter(card => card.key !== key);
    },

    setStatus(payload) {
      if (!payload?.call_record_id || !payload.status) return;
      this.statusByCall = {
        ...this.statusByCall,
        [String(payload.call_record_id)]: payload.status,
      };
    },

    clearAll() {
      timers.forEach(timer => clearTimeout(timer));
      timers.clear();
      this.cards = [];
      this.statusByCall = {};
    },

    clearTimer(key) {
      clearTimeout(timers.get(key));
      timers.delete(key);
    },
  },
});
